/**
 * Field — поле ввода с опциональными подписью, подсказкой, ошибкой и префиксом/суффиксом.
 */
import type { InputHTMLAttributes, ReactNode } from "react";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  hint?: string;
  error?: string;
  prefix?: ReactNode;
  suffix?: ReactNode;
};

export function Field({ label, hint, error, prefix, suffix, className = "", ...rest }: Props) {
  return (
    <label className="block">
      {label && <span className="mb-1.5 block text-[13px] text-white/45">{label}</span>}
      <div className={`flex items-center gap-2 rounded-2xl border bg-surface-card px-4 py-3.5 ${error ? "border-red-500/60" : "border-white/[0.06]"}`}>
        {prefix && <span className="text-white/45">{prefix}</span>}
        <input
          {...rest}
          className={`min-w-0 flex-1 bg-transparent text-[16px] text-white outline-none [color-scheme:dark] placeholder:text-white/30 ${className}`}
        />
        {suffix && <span className="text-white/45">{suffix}</span>}
      </div>
      {(hint || error) && (
        <span className={`mt-1.5 block text-[12px] ${error ? "text-red-400" : "text-white/40"}`}>
          {error || hint}
        </span>
      )}
    </label>
  );
}